import React from 'react';
import { CheckCircle2, XCircle, Target } from 'lucide-react';
import { motion } from 'framer-motion';
const yesList = ['Para empleadas que busquen una alternativa a su trabajo.', 'Para emprendedoras que no sepan crear contenido o no dominen bien las ventas en su negocio aun.', 'Para creadoras de contenido / travel bloggers / ugc que aun no esten monetizando sus videos.'];
const noList = ['Para quienes no quieran aprender y ejecutar realmente el metodo.', 'Para quienes no se dejan guiar y enseñar.', 'Para quienes no quieren invertir ni unas pocas horas a la semana en crear videos.'];
export function WhoIsThisForSection() {
  return <section className="px-6 py-12 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-505">
      <div className="w-full max-w-5xl relative rounded-[3rem] p-[2px] bg-gradient-to-b from-[#D98BAF]/50 via-brand-navy to-brand-navy shadow-[0_20px_60px_-15px_rgba(217,139,175,0.2)]" data-id="element-506">
        <div className="bg-brand-navy rounded-[2.9rem] px-6 py-10 md:px-12 md:py-14 relative overflow-hidden flex flex-col items-center" data-id="element-507">
          {/* Ambient glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#D98BAF]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-508" />

          <div className="inline-flex items-center gap-2 bg-[#D98BAF]/15 border border-[#D98BAF]/40 text-[#D98BAF] font-bold text-[12px] md:text-sm uppercase tracking-[0.2em] px-6 py-2.5 rounded-full mb-8 backdrop-blur-sm relative z-10" data-id="element-509">
            <Target size={16} strokeWidth={2.5} data-id="element-510" />
            Tu perfil
          </div>

          <h2 className="font-serif font-bold text-3xl md:text-5xl text-white mb-12 leading-tight relative z-10" data-id="element-511">
            ¿Para quién{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D98BAF] to-brand-pinkDark" data-id="element-512">
              es este programa
            </span>
            ?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full relative z-10" data-id="element-513">
            {/* YES Column */}
            <div className="bg-white/[0.03] border border-emerald-500/30 rounded-3xl p-8 flex flex-col items-start text-left shadow-[0_0_30px_rgba(16,185,129,0.05)] relative overflow-hidden" data-id="element-514">
              <div className="absolute top-0 right-0 w-32 h-32 bg-emerald-500/10 blur-[50px] rounded-full pointer-events-none" data-id="element-515" />
              <h3 className="font-black text-2xl text-emerald-400 mb-6 uppercase tracking-tight flex items-center gap-3" data-id="element-516">
                <CheckCircle2 size={28} strokeWidth={3} data-id="element-517" />
                PARA QUIÉN SÍ ES
              </h3>
              <ul className="space-y-5" data-id="element-518">
                {yesList.map((item, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: i * 0.1
              }} className="flex items-start gap-3" data-id="element-519">
                    <span className="text-emerald-400 font-bold mt-1" data-id="element-520">•</span>
                    <span className="text-white/90 font-medium text-lg leading-relaxed" data-id="element-521">
                      {item}
                    </span>
                  </motion.li>)}
              </ul>
            </div>

            {/* NO Column */}
            <div className="bg-white/[0.02] border border-red-500/30 rounded-3xl p-8 flex flex-col items-start text-left shadow-[0_0_30px_rgba(239,68,68,0.05)] relative overflow-hidden" data-id="element-522">
              <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/10 blur-[50px] rounded-full pointer-events-none" data-id="element-523" />
              <h3 className="font-black text-2xl text-red-400 mb-6 uppercase tracking-tight flex items-center gap-3" data-id="element-524">
                <XCircle size={28} strokeWidth={3} data-id="element-525" />
                PARA QUIÉN NO ES
              </h3>
              <ul className="space-y-5" data-id="element-526">
                {noList.map((item, i) => <motion.li key={i} initial={{
                opacity: 0,
                x: 10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: i * 0.1
              }} className="flex items-start gap-3" data-id="element-527">
                    <span className="text-red-400 font-bold mt-1" data-id="element-528">•</span>
                    <span className="text-white/70 font-medium text-lg leading-relaxed" data-id="element-529">
                      {item}
                    </span>
                  </motion.li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}